import { SecureRoute } from '@okta/okta-react';
import React, { FC } from 'react';
import { Switch } from 'react-router-dom';
import { DocumentTemplateDetailPage } from 'components/organisms/templates/documents/document-detail';
import { NewDocumentTemplatePage } from 'components/organisms/templates/documents/new-document-detail';
import { FormTemplateDetailsPage } from 'components/organisms/templates/forms/form-details-page';
import { NewFormTemplatePage } from 'components/organisms/templates/forms/new-form-detail';
import {
  NewStatusUpdatesTemplatePage,
  StatusUpdatesTemplateDetailPage,
} from 'components/organisms/templates/status-updates';
import { RoutePaths } from 'constant';
import { useDefaultPlaceholderWSUpdates } from 'hooks/use-default-placeholder-websocket';
import { TemplateListRoute } from './list';
import {
  ProjectTemplateDetailRoute,
  ProjectTemplateNewRoute,
} from './projects';

const Routes = [
  {
    path: RoutePaths.newProjectTemplate,
    component: ProjectTemplateNewRoute,
  },
  {
    path: RoutePaths.projectTemplate,
    component: ProjectTemplateDetailRoute,
  },
  {
    path: RoutePaths.newDocumentTemplate,
    component: NewDocumentTemplatePage,
  },
  {
    path: RoutePaths.documentTemplate,
    component: DocumentTemplateDetailPage,
  },
  {
    path: RoutePaths.newStatusUpdateTemplate,
    component: NewStatusUpdatesTemplatePage,
  },
  {
    path: RoutePaths.statusUpdateTemplate,
    component: StatusUpdatesTemplateDetailPage,
  },
  {
    path: RoutePaths.newFormTemplate,
    component: NewFormTemplatePage,
  },
  {
    path: RoutePaths.formTemplate,
    component: FormTemplateDetailsPage,
  },
  {
    path: RoutePaths.templates,
    component: TemplateListRoute,
  },
];

export const TemplatesRoute: FC = () => {
  useDefaultPlaceholderWSUpdates();

  return (
    <Switch>
      {Routes.map((route) => (
        <SecureRoute
          key={route.path}
          path={route.path}
          component={route.component}
        />
      ))}
    </Switch>
  );
};
